<template>
    <div class="ui-show-more">
        <div
            ref="content"
            class="ui-show-more__content"
            :class="{
                'ui-show-more__content_closed': !localValue && heightIsGreatherScroll,
            }"
        >
            <slot />
        </div>
        <slot name="activator" :toggle="toggle" :heightIsGreatherScroll="heightIsGreatherScroll">
            <button
                v-if="heightIsGreatherScroll"
                type="button"
                class="button"
                @click="toggle"
            >
                {{ buttonText }}
            </button>
        </slot>
    </div>
</template>
<script>
import Velocity from 'velocity-animate';

export default {
    name: 'UiShowMore',
    props: {
        value: Boolean,
        height: {
            type: Number,
            default: 200,
        },
        duration: {
            type: Number,
            default: 300,
        },
        buttonText: {
            type: String,
            default: 'Показать больше',
        },
    },
    data() {
        return {
            localValue: false,
            heightIsGreatherScroll: false,
        };
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.localValue = val;
            },
        },
        localValue(val) {
            this.toggleContent(val);
            if (val === this.value) return;

            this.$emit('input', val);
        },
    },
    methods: {
        toggle() {
            this.localValue = !this.localValue;
        },
        toggleContent(val, initial = false) {
            const el = this.$refs.content;
            if (!el) return;

            const height = val ? el.scrollHeight : this.height;
            if (initial) {
                el.style.height = `${height}px`;
            } else Velocity(el, { height }, {
                duration: this.duration,
                complete: this.onToggleEnd,
                progress: this.onToggleProgress,
            });
        },
        onToggleEnd() {
            this.$emit('toggle-end');
        },
        onToggleProgress() {
            this.$emit('toggle-progress');
        },
    },
    mounted() {
        const el = this.$refs.content;
        this.heightIsGreatherScroll = el.scrollHeight > this.height;

        this.toggleContent(this.localValue, true);
    },
};
</script>
<style lang="scss">
.ui-show-more {
    &__content {
        overflow: hidden;

        &_closed {
            mask-repeat: no-repeat;
            mask-image: linear-gradient(180deg, rgba(0,0,0,1) 20%, rgba(0,0,0,0) 100%);
            mask-mode: alpha;
        }
    }
}
</style>
